import { VenueRequestFile } from '@go-shared/types/groupBooking';
import { RequestMethod, apiGet, apiPut, apiRequest, apiPost } from '.';
import { Brand, BrandVenueType } from '../../../shared/types/brand';

export async function getBrand(brandId: string): Promise<Brand> {
  return apiGet(`/brand/${brandId}`);
}

export async function updateBrand(brandId: string, newBrand: Brand): Promise<Brand> {
  return apiPut(`/brand/${brandId}`, newBrand);
}

export async function updateVenueTypes(
  brandId: string,
  venueTypes: BrandVenueType[]
): Promise<Brand> {
  return apiPut(`/brand/${brandId}/venue-type`, venueTypes);
}

export async function uploadBrandLogo(brandId: string, file: File): Promise<Brand> {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest(RequestMethod.Post, `/brand/${brandId}/logo`, true, null, fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export async function uploadImage(brandId: string, file: File): Promise<VenueRequestFile> {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest(RequestMethod.Post, `/brand/${brandId}/image`, true, null, fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export async function uploadImageVariant(brandId: string, file: File): Promise<VenueRequestFile> {
  const fd = new FormData();
  fd.append('file', file);

  return apiRequest(RequestMethod.Post, `/brand/${brandId}/image-variant`, true, null, fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export async function exportBrandSettings(brandId: string): Promise<{ location: string }> {
  return apiPost(`/export/brand/${brandId}/settings`);
}
